import { BLACK_d, BLACK_e } from "baseStyles";
import { MOBILE_LAYOUT_LENGTH } from "constants/UIConstants";
import styled from "styled-components";

export const Wrapper = styled.div`
  width: 100%;
  height: 95.4rem;
  position: relative;
  overflow: hidden;
  & > img {
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: -99;
  }
  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    height: 40rem;
    & > img {
      width: 82.9rem;
      left: -26rem;
    }
  }
`;

export const Design = styled.div`
  position: absolute;
  height: 100%;
  width: 175rem;
  background: linear-gradient(90deg, #000000 0%, rgba(0, 0, 0, 0) 100%);
  z-index: -98;
  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    width: 52rem;
  }
`;

export const TextBox = styled.div`
  margin-top: 24.6rem;
  margin-left: 36rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;

  & > span:nth-child(1) {
    font-weight: 700;
    font-size: 5.2rem;
    line-height: 9.2rem;
  }
  & > div,
  span:nth-child(2) {
    font-weight: 300;
    font-size: 2rem;
    line-height: 3.6rem;

    width: ${(props) => (props.language === "en" ? "78rem" : "52rem")};
    color: ${BLACK_e};
  }
  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    margin-top: 7.3rem;
    margin-left: 20px;
    gap: 1.5rem;
    & > span:nth-child(1) {
      font-size: 2.4rem;
      line-height: 4.2rem;
    }
    & > div,
    span:nth-child(2) {
      font-weight: 300;
      font-size: 1.6rem;
      line-height: 2.8rem;
      width: 31.8rem;
    }
  }
`;
